import { useEffect, useState } from "react";
import { signupOptions } from "@/lib/auth-api";
import type { SignupOptionsState } from "@/lib/signup-gate";

/**
 * Флаги регистрации у демона (`GET /api/auth/signup-options`, Д2). Читаются
 * заново на каждую смену `key` — состояния сессии: флаги меняются в PostHog
 * без перезапуска демона, а читать их нужно и на форме входа, и в меню.
 * Пока `enabled` ложно, запрос не идёт.
 */
export function useSignupOptions(enabled: boolean, key: string): SignupOptionsState {
  const [state, setState] = useState<SignupOptionsState>({ status: "loading" });

  // biome-ignore lint/correctness/useExhaustiveDependencies: `key` — только повод перечитать флаги.
  useEffect(() => {
    if (!enabled) {
      return;
    }
    let cancelled = false;
    setState({ status: "loading" });
    signupOptions().then((result) => {
      if (cancelled) {
        return;
      }
      setState(
        result.status === "ok"
          ? { status: "ready", options: result.options }
          : { status: "unavailable" },
      );
    });
    return () => {
      cancelled = true;
    };
  }, [enabled, key]);

  return state;
}
